export default __webpack_public_path__ + "static/media/time.590e8639.svg";